import type { DashboardState, ForwardingConnection } from '../types/forwarding'
import type { ForwardingSetup } from './mobileForwarding'

// Example accounts used to preview each Home dashboard state from Screens.

const PHONE = '+1 (415) 555-0142'
const SETUP: ForwardingSetup = {
  carrierId: 'tmobile',
  os: 'ios',
  androidBrand: 'samsung',
  method: 'code',
}

const base = {
  numberType: 'mobile' as const,
  phoneNumber: PHONE,
  mode: 'conditional' as const,
  setup: SETUP,
  draft: null,
  needsAttention: false,
}

export const DEMO_CONNECTIONS: Record<DashboardState, ForwardingConnection | null> = {
  firstTime: null,
  inactive: { ...base, rules: { busy: 'off', unanswered: 'off', unreachable: 'off' } },
  active: { ...base, rules: { busy: 'verified', unanswered: 'verified', unreachable: 'verified' } },
  partial: { ...base, rules: { busy: 'verified', unanswered: 'verified', unreachable: 'off' } },
  incomplete: {
    ...base,
    rules: { busy: 'needsSetup', unanswered: 'needsSetup', unreachable: 'needsSetup' },
    draft: { screen: 'code', method: 'code', codeStepIdx: 1, settingsIdx: 0 },
  },
  attention: {
    ...base,
    rules: { busy: 'verified', unanswered: 'verified', unreachable: 'verified' },
    needsAttention: true,
  },
}
